import { SendItemUploadFeedbackArgs } from '../types/after-upload-actions'

export const sendItemUploadFeedbackArgsToParams = ({
  rating,
  comment,
  finalized,
  itemId,
  feedbackStatementIds,
}: SendItemUploadFeedbackArgs) => ({
  item_id: itemId,
  rating,
  comment,
  finalized,
  feedback_statement_ids: feedbackStatementIds,
})
